<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="loader-wrapper" v-if="loading">
      <!-- <div class="loader-index"><span></span></div> -->
      <!-- <div class="loader-dot"><span></span></div>
      <img
        class="loader-logo"
        :src="require('@/assets/images/logo/logo-circle.png')"
        alt=""
      /> -->
      <!-- <el-image
        class="loader-logo"
        :src="require('@/assets/images/logo/logo-circle.png')"
        fit="cover"
      /> -->
    </div>
    <div v-else>
      <!-- <div class="page-wrapper" id="pageWrapper" :class="{'horizontal-wrapper':sidebar=='horizontal-wrapper','compact-wrapper':sidebar=='compact-sidebar1'}"> -->
      <div class="page-wrapper" id="pageWrapper" :class="layoutobj">
        <div class="page-header" :class="{ close_icon: !togglesidebar }">
          <Header @clicked="sidebar_toggle" @filterConfirm="filterConfirm" />
        </div>

        <div class="page-body-wrapper bg-me-primary-1">
          <!-- <div class="bg-overlay" :class="{active: activeoverlay }" @click="removeoverlay()"></div> -->
          <div
            class="sidebar-wrapper bg-me-primary text-white"
            :class="[{ close_icon: !togglesidebar }]"
            :sidebar-layout="svg == 'stroke-svg' ? 'stroke-svg' : 'fill-svg'"
          >
            <Sidebar @clicked="sidebar_toggle" />
          </div>
          <div class="page-body bg-me-primary-1" @click="hidesecondmenu()">
            <transition name="fadeIn" enter-active-class="animated fadeIn">
              <router-view class="view"></router-view>
            </transition>
          </div>
          <Footer />
        </div>
        <!-- <Customizer/> -->
        <TapTop />
      </div>
    </div>
  </div>
</template>

<script>
import { ElLoading } from "element-plus";
import { mapState, mapGetters } from "vuex";

import { layoutClasses } from "../constants/layout";
import Header from "./header";
import Sidebar from "./sidebar";
import Footer from "./footer.vue";
// import Customizer from './customizer';
import TapTop from "./tapTop.vue";

export default {
  //   name: 'mainPage',
  props: ["sidebar_toggle_var"],
  components: {
    Header,
    Sidebar,
    Footer,
    // Customizer,
    TapTop,
  },
  data() {
    return {
      loading: true,
      mobileheader_toggle_var: false,
      // eslint-disable-next-line vue/no-dupe-keys
      sidebar_toggle_var: false,
      horizontal_Sidebar: true,
      resized: false,
      layoutobj: {},
    };
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.data,
      layout: (state) => state.layout.layout,
      togglesidebar: (state) => state.menu.togglesidebar,
      activeoverlay: (state) => state.menu.activeoverlay,
      svg: (state) => state.layout.svg,
    }),
    ...mapGetters({
      sidebar: "layout/sidebar",
    }),
    layoutobject: {
      get: function () {
        // return 'hello'
        return JSON.parse(
          JSON.stringify(
            layoutClasses.find(
              (item) => Object.keys(item).pop() === this.layout.settings.layout
            )
          )
        )[this.layout.settings.layout];
      },
      set: function () {
        this.layoutobj = layoutClasses.find(
          (item) => Object.keys(item).pop() === this.layout.settings.layout
        );
        this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[
          this.layout.settings.layout
        ];
        return this.layoutobj;
      },
    },
  },
  watch: {
    $route() {
      const loadingInstance = ElLoading.service({
      lock: true,
      background: '#0d3937',
      spinner: `<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path class="spinner-outer" d="M42.4483 26.5718C42.6964 26.5919 42.9143 26.4069 42.9282 26.1584C43.0955 23.149 42.5068 20.143 41.2125 17.4157C39.8538 14.5526 37.7653 12.0975 35.157 10.2974C32.5488 8.4972 29.5126 7.41531 26.3537 7.16044C23.1948 6.90558 20.0244 7.48672 17.1613 8.84546C14.2982 10.2042 11.8431 12.2927 10.043 14.9009C8.2428 17.5092 7.16091 20.5454 6.90605 23.7043C6.65118 26.8632 7.23233 30.0335 8.59106 32.8967C9.88533 35.6239 11.8417 37.9809 14.2788 39.7543C14.4801 39.9008 14.7611 39.8489 14.9025 39.644V39.644C15.0439 39.4392 14.9921 39.1589 14.791 39.0122C12.4841 37.3288 10.6319 35.0945 9.40545 32.5102C8.11455 29.79 7.56243 26.778 7.80457 23.7768C8.0467 20.7756 9.07457 17.891 10.7849 15.413C12.4952 12.9349 14.8276 10.9507 17.5478 9.65985C20.268 8.36895 23.28 7.81683 26.2812 8.05896C29.2824 8.3011 32.167 9.32897 34.645 11.0393C37.123 12.7496 39.1072 15.082 40.3981 17.8022C41.6245 20.3865 42.1841 23.2343 42.0293 26.0859C42.0158 26.3344 42.2001 26.5518 42.4483 26.5718V26.5718Z" fill="#78BE20"/>
           <path class="spinner-inner" d="M24.5807 4.79957C24.5755 4.54573 24.3653 4.34369 24.1117 4.35461C20.6458 4.50374 17.2705 5.52325 14.2986 7.32233C11.1956 9.20083 8.64162 11.8631 6.89352 15.0414C5.14543 18.2198 4.26477 21.8023 4.34006 25.4289C4.41217 28.9022 5.35866 32.2987 7.08874 35.3056C7.21536 35.5256 7.49851 35.5949 7.7157 35.4634V35.4634C7.9329 35.3319 8.00187 35.0495 7.87548 34.8293C6.22886 31.9606 5.32804 28.7217 5.25929 25.4098C5.18735 21.9446 6.02882 18.5215 7.69914 15.4845C9.36946 12.4476 11.8098 9.90379 14.7748 8.10887C17.6086 6.39337 20.8263 5.41969 24.1308 5.27407C24.3844 5.2629 24.586 5.05341 24.5807 4.79957V4.79957Z" fill="#4F99DC"/>
           <g class="spinner-logo" clip-path="url(#clip0_2457_6002)">
           <path d="M28.9827 21.7969L28.6812 20.4565L34.6832 20.4927L34.6751 21.8311L28.9827 21.7969Z" fill="white"/>
           <path d="M29.9236 25.9722L29.6221 24.6318L34.658 24.6622L34.65 26.0006L29.9236 25.9722Z" fill="white"/>
           <path d="M32.1766 18.4167C32.9569 18.4214 33.5849 19.0293 33.5804 19.7755C33.5759 20.5217 32.9406 21.122 32.1603 21.1173C31.38 21.1126 30.752 20.5047 30.7565 19.7585C30.761 19.0123 31.3963 18.412 32.1766 18.4167Z" fill="#50B443"/>
           <path d="M26.6525 22.5317L26.5361 22.531L24.4287 29.4146L22.7517 29.4045L20.6976 22.4959L20.596 22.4953L18.8733 30.0729L17.3846 30.0639L19.697 20.4027L21.431 20.4132L23.5406 27.559L23.6422 27.5597L25.8526 20.4398L27.5866 20.4502L29.7676 30.1385L28.3086 30.1297L26.6501 22.5317L26.6525 22.5317Z" fill="white"/>
           <path d="M28.301 30.1319L30.8623 30.1473L30.5608 28.807L34.6331 28.8315L34.6251 30.17L28.301 30.1319Z" fill="white"/>
           <path d="M17.1287 26.0256C17.909 26.0303 18.5371 26.6382 18.5326 27.3844C18.5281 28.1306 17.8928 28.7309 17.1125 28.7262C16.3322 28.7215 15.7042 28.1136 15.7087 27.3674C15.7132 26.6212 16.3485 26.0209 17.1287 26.0256Z" fill="#50B443"/>
           </g>
          <defs>
          <clipPath id="clip0_2457_6002">
          <rect width="18.9328" height="11.7383" fill="white" transform="translate(15.7632 18.3179) rotate(0.345054)"/>
          </clipPath>
          </defs>
          </svg>
      `,
    });
      setTimeout(() => {
        this.loading = !this.loading;
        loadingInstance.close();
      }, 250);
      this.loading = !this.loading;
      this.menuItems.filter((items) => {
        if (items.path === this.$route.path)
          this.$store.dispatch("menu/setActiveRoute", items);
        if (!items.children) return false;
        items.children.filter((subItems) => {
          if (subItems.path === this.$route.path)
            this.$store.dispatch("menu/setActiveRoute", subItems);
          if (!subItems.children) return false;
          subItems.children.filter((subSubItems) => {
            if (subSubItems.path === this.$route.path)
              this.$store.dispatch("menu/setActiveRoute", subSubItems);
          });
        });
      });
      this.layoutobj = layoutClasses.find(
        (item) => Object.keys(item).pop() === this.layout.settings.layout
      );
      // console.log("layobj==>", this.layoutobj);

      if (
        (window.innerWidth < 991 &&
          this.layout.settings.layout === "LosAngeles") ||
        (window.innerWidth < 991 &&
          this.layout.settings.layout === "Singapore") ||
        (window.innerWidth < 991 && this.layout.settings.layout === "Barcelona")
      ) {
        const newlayout = JSON.parse(
          JSON.stringify(this.layoutobj).replace(
            "horizontal-wrapper",
            "compact-wrapper"
          )
        );
        // console.log("newlayobj==>",newlayout)

        this.layoutobj = JSON.parse(JSON.stringify(newlayout))[
          this.layout.settings.layout
        ];
      } else {
        this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[
          this.layout.settings.layout
        ];
      }
    },
    sidebar_toggle_var: function () {
      this.resized =
        this.width <= 991 ? !this.sidebar_toggle_var : this.sidebar_toggle_var;
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.resized = this.sidebar_toggle_var;
    this.$store.dispatch("layout/set");
    // this.$router.replace({ 'query': null }).catch(err => err);
    this.layout.settings.layout = this.$route.query.layout
      ? this.$route.query.layout
      : "Dubai";
    this.layoutobj = layoutClasses.find(
      (item) => Object.keys(item).pop() === this.layout.settings.layout
    );
    this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[
      this.layout.settings.layout
    ];
  },
  methods: {
    sidebar_toggle(value) {
      // eslint-disable-next-line vue/no-mutating-props
      this.sidebar_toggle_var = !value;
    },
    mobiletoggle_toggle(value) {
      this.mobileheader_toggle_var = value;
    },
    handleResize() {
      this.$store.dispatch("menu/resizetoggle");
    },
    removeoverlay() {
      this.$store.state.menu.activeoverlay = false;
      if (window.innerWidth < 991) {
        this.$store.state.menu.togglesidebar = false;
      }
      this.menuItems.filter((menuItem) => {
        menuItem.active = false;
      });
    },
    hidesecondmenu() {
      if (this.layoutobject.split(" ").includes("compact-sidebar")) {
        this.menuItems.filter((menuItem) => {
          menuItem.active = false;
        });
      }
      if (window.innerWidth < 991) {
        this.$store.state.menu.togglesidebar = false;
      }
    },
    filterConfirm(event) {
      console.log(event);
      this.$store.state.menu.filterOpen = event;
    },
  },
  mounted() {
    // setTimeout(()=>{
    this.loading = false;

    // },2000)
  },
};
</script>

<style scoped>
@keyframes grow-logo {
  0% {
    transform: scale(0.5);
    /* background: #16C7F9; */
  }
  50% {
    transform: scale(1);
    /* background: var(--theme-secondary); */
  }
}
.loader-logo {
  width: 7em;
  height: 7em;
  background: white;
  border-radius: 50%;
  position: absolute;
  transform: scale(0.5);
  animation: grow-logo 2s cubic-bezier(0.14, 0.05, 0.55, 0.5) infinite alternate;
}

.loader-wrapper {
  background-color: #0d3937 !important;
}

.loader-wrapper .loader-dot {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  filter: url("#goo");
}

.loader-wrapper .loader-dot span {
  width: 2em;
  height: 2em;
  background: #78be20;
  border-radius: 50%;
  margin-right: 2em;
  position: relative;
  transform: translateX(7em);
  animation: move 4s ease-in-out infinite;
}

.loader-wrapper .loader-dot span:before {
  content: "";
  width: 2em;
  height: 2em;
  background: #547477;
  border-radius: 50%;
  position: absolute;
  left: 3em;
  transform: translateX(0em);
  animation: shrink 2s ease-in-out infinite;
}

.loader-wrapper .loader-dot span:after {
  content: "";
  width: 2em;
  height: 2em;
  background: #234b49;
  border-radius: 50%;
  position: absolute;
  right: 3em;
  transform: translateX(0em);
  animation: shrink 2s ease-in-out infinite;
}
</style>

